(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9685],{

/***/ 62810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

exports.Z = _default;

/***/ }),

/***/ 56419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button_Button; },
  "Z": function() { return /* reexport */ components_Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./components/Button/Button.module.scss
var Button_module = __webpack_require__(85474);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./components/Button/Button.tsx




// TODO: spread the default props so they can actually be used when using this button - problems with some HTML button props messing with mui button props
var Button_Button = function(param) {
    var children = param.children, onClick = param.onClick, _href = param.href, href = _href === void 0 ? "" : _href, disabled = param.disabled, trackFunction = param.trackFunction, iconLeft = param.iconLeft, iconRight = param.iconRight, className = param.className, _type = param.type, type = _type === void 0 ? "button" : _type, _variant = param.variant, variant = _variant === void 0 ? "contained" : _variant, _colorVariant = param.colorVariant, colorVariant = _colorVariant === void 0 ? "primary" : _colorVariant;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Button_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: (0,clsx_m/* default */.Z)((Button_module_default()).myButton, variant === "contained" ? (Button_module_default()).contained : (Button_module_default()).outlined, colorVariant === "secondary" && (Button_module_default()).secondary),
            variant: variant,
            href: href,
            type: type,
            disabled: disabled,
            onClick: function() {
                if (disabled) {
                    return;
                }
                var ref;
                trackFunction === null || trackFunction === void 0 ? void 0 : trackFunction({
                    "element text": (ref = children === null || children === void 0 ? void 0 : children.toString()) !== null && ref !== void 0 ? ref : "",
                    "element type": "button"
                });
                onClick === null || onClick === void 0 ? void 0 : onClick();
            },
            startIcon: iconLeft,
            endIcon: iconRight,
            children: children
        })
    });
};
/* harmony default export */ var components_Button_Button = (Button_Button);

;// CONCATENATED MODULE: ./components/Button/index.ts



/***/ }),

/***/ 9685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ HeroHeaderComponent_HeroHeaderComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var Button = __webpack_require__(56419);
// EXTERNAL MODULE: ./components/TickList/index.ts + 2 modules
var TickList = __webpack_require__(77135);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__(30724);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./components/CMS/HeroHeaderComponent/HeroHeaderComponent.module.scss
var HeroHeaderComponent_module = __webpack_require__(30509);
var HeroHeaderComponent_module_default = /*#__PURE__*/__webpack_require__.n(HeroHeaderComponent_module);
;// CONCATENATED MODULE: ./components/CMS/HeroHeaderComponent/HeroHeaderComponent.tsx










var longHeadingThreshold = 50;
var HeroHeaderComponent = function(param) {
    var hero_header_collection = param.hero_header_collection, _imageAlignment = param.imageAlignment, imageAlignment = _imageAlignment === void 0 ? "left" : _imageAlignment, darkMode = param.darkMode;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var heading = hero_header_collection.heading, heroParagraph = hero_header_collection.heroParagraph, bulletList = hero_header_collection.bulletList, primaryButtonText = hero_header_collection.primaryButtonText, primaryButtonUrl = hero_header_collection.primaryButtonUrl, secondaryButtonText = hero_header_collection.secondaryButtonText, secondaryButtonUrl = hero_header_collection.secondaryButtonUrl, proofText = hero_header_collection.proofText, heroImage = hero_header_collection.heroImage, collageImage = hero_header_collection.collageImage;
    var isLongHeading = heading.length > longHeadingThreshold;
    var heroImageUrl = "";
    try {
        var _url;
        heroImageUrl = (_url = heroImage.url) !== null && _url !== void 0 ? _url : "";
    } catch (e) {
    // nothing to be done here
    }
    var _richTextItem, _url1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((HeroHeaderComponent_module_default()).heroHeaderContainer, darkMode && (HeroHeaderComponent_module_default()).darkMode),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((HeroHeaderComponent_module_default()).contentContainer, imageAlignment === "right" && (HeroHeaderComponent_module_default()).imageRight),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HeroHeaderComponent_module_default()).contentTextContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                            className: (0,clsx_m/* default */.Z)((HeroHeaderComponent_module_default()).heading, isLongHeading && (HeroHeaderComponent_module_default()).longHeading),
                            children: heading
                        }),
                        heroParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (HeroHeaderComponent_module_default()).paragraph,
                            children: heroParagraph
                        }),
                        bulletList && /*#__PURE__*/ (0,jsx_runtime.jsx)(TickList/* TickList */.l, {
                            className: (HeroHeaderComponent_module_default()).heroTickList,
                            variant: "medrecruitTick",
                            items: bulletList,
                            itemRenderFunction: function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                                    children: (_richTextItem = item.richTextItem) !== null && _richTextItem !== void 0 ? _richTextItem : ""
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HeroHeaderComponent_module_default()).buttonContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    colorVariant: darkMode ? "secondary" : "primary",
                                    href: primaryButtonUrl,
                                    trackFunction: function(eventProps) {
                                        track("Click", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventProps), {
                                            action: "Hero header primary cta"
                                        }));
                                    },
                                    children: primaryButtonText
                                }),
                                secondaryButtonText && secondaryButtonUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    colorVariant: darkMode ? "secondary" : "primary",
                                    href: secondaryButtonUrl,
                                    variant: "outlined",
                                    trackFunction: function(eventProps) {
                                        track("Click", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventProps), {
                                            action: "Hero header secondary cta"
                                        }));
                                    },
                                    children: secondaryButtonText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HeroHeaderComponent_module_default()).miniTestimonialContainer,
                            children: [
                                collageImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HeroHeaderComponent_module_default()).collageImageWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "",
                                        src: (_url1 = collageImage.url) !== null && _url1 !== void 0 ? _url1 : "",
                                        "aria-hidden": "true",
                                        layout: "fill"
                                    })
                                }),
                                proofText && /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                                    className: (HeroHeaderComponent_module_default()).testimonialText,
                                    children: proofText
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HeroHeaderComponent_module_default()).imageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        src: heroImageUrl,
                        "aria-hidden": "true",
                        width: 588,
                        height: 440,
                        priority: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var HeroHeaderComponent_HeroHeaderComponent = (HeroHeaderComponent);

;// CONCATENATED MODULE: ./components/CMS/HeroHeaderComponent/index.ts



/***/ }),

/***/ 77135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ TickList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckBox.js
var CheckBox = __webpack_require__(62810);
// EXTERNAL MODULE: ./components/TickList/TickList.module.scss
var TickList_module = __webpack_require__(6705);
var TickList_module_default = /*#__PURE__*/__webpack_require__.n(TickList_module);
;// CONCATENATED MODULE: ./components/TickList/assets/medrecruitTick.svg
var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgMedrecruitTick = function SvgMedrecruitTick(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#00CBAB"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m15.056 21.76-4.522-4.522 1.13-1.13 3.392 3.39 7.279-7.278 1.13 1.13-8.409 8.41Z",
    fill: "#11181C"
  })));
};
/* harmony default export */ var medrecruitTick = (SvgMedrecruitTick);
;// CONCATENATED MODULE: ./components/TickList/TickList.tsx






var TickList = function(param) {
    var items = param.items, variant = param.variant, className = param.className, itemRenderFunction = param.itemRenderFunction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((TickList_module_default()).container, variant === "small" && (TickList_module_default()).container_small, className),
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TickList_module_default()).listItem,
                children: [
                    variant === "medrecruitTick" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(medrecruitTick, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                        className: (TickList_module_default()).checkIcon
                    }),
                    itemRenderFunction ? itemRenderFunction(item) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: item
                    })
                ]
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./components/TickList/index.ts



/***/ }),

/***/ 85474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__wxGrQ","myButton":"Button_myButton__0wSRl","contained":"Button_contained__78t0q","secondary":"Button_secondary__X4hrj","outlined":"Button_outlined__09ghW"};

/***/ }),

/***/ 30509:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroHeaderContainer":"HeroHeaderComponent_heroHeaderContainer__zo6z7","contentContainer":"HeroHeaderComponent_contentContainer__MxXHH","imageRight":"HeroHeaderComponent_imageRight__pA4qg","contentTextContainer":"HeroHeaderComponent_contentTextContainer__2tOcr","heading":"HeroHeaderComponent_heading__NCl2J","longHeading":"HeroHeaderComponent_longHeading__NnlM5","paragraph":"HeroHeaderComponent_paragraph__1mQrq","heroTickList":"HeroHeaderComponent_heroTickList__tW8dn","buttonContainer":"HeroHeaderComponent_buttonContainer__Nphyl","miniTestimonialContainer":"HeroHeaderComponent_miniTestimonialContainer__y0isZ","collageImageWrapper":"HeroHeaderComponent_collageImageWrapper__82NND","testimonialText":"HeroHeaderComponent_testimonialText__nJwXY","imageContainer":"HeroHeaderComponent_imageContainer__6mU6i","darkMode":"HeroHeaderComponent_darkMode__JKJNY"};

/***/ }),

/***/ 6705:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TickList_container__Q0_9p","listItem":"TickList_listItem__KXl7I","checkIcon":"TickList_checkIcon__W2Bql","container_small":"TickList_container_small__k5lqe"};

/***/ })

}]);